import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import {
  MessageSquareQuote,
  Building2,
  BarChart3,
} from "lucide-react";
import { TestimonialsTab } from "./landing-admin/TestimonialsTab";
import { EntitiesTab } from "./landing-admin/EntitiesTab";
import { MetricsTab } from "./landing-admin/MetricsTab";

/**
 * AdminLandingConfigPage — Fase C
 *
 * Configura las secciones dinámicas del landing público:
 *  - Testimonios (curados desde NPS existentes)
 *  - Entidades (CRUD libre con logo)
 *  - Métricas (catálogo de KPIs computados desde DB; admin elige cuáles mostrar)
 *
 * Backend: ver routers/admin_landing.py (Fase B)
 */
export default function AdminLandingConfigPage() {
  const [activeTab, setActiveTab] = useState("testimonios");

  return (
    <div data-testid="admin-landing-config-page" className="space-y-6">
      <header className="border-b border-gray-200 pb-4">
        <h1 className="font-serif text-2xl text-gray-900">Configuración del Landing</h1>
        <p className="text-sm text-gray-600 mt-1">
          Gestiona testimonios, entidades y métricas que se muestran al público en{" "}
          <code className="text-xs bg-gray-100 px-1.5 py-0.5 rounded">/</code>.
          Los cambios son visibles inmediatamente.
        </p>
      </header>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="bg-white border border-gray-200 h-auto p-1" data-testid="landing-config-tabs">
          <TabsTrigger value="testimonios" className="gap-2 data-[state=active]:bg-primary data-[state=active]:text-white" data-testid="tab-testimonios">
            <MessageSquareQuote className="h-4 w-4" /> Testimonios
          </TabsTrigger>
          <TabsTrigger value="entidades" className="gap-2 data-[state=active]:bg-primary data-[state=active]:text-white" data-testid="tab-entidades">
            <Building2 className="h-4 w-4" /> Entidades
          </TabsTrigger>
          <TabsTrigger value="metricas" className="gap-2 data-[state=active]:bg-primary data-[state=active]:text-white" data-testid="tab-metricas">
            <BarChart3 className="h-4 w-4" /> Métricas
          </TabsTrigger>
        </TabsList>

        <TabsContent value="testimonios" className="mt-6">
          <TestimonialsTab />
        </TabsContent>
        <TabsContent value="entidades" className="mt-6">
          <EntitiesTab />
        </TabsContent>
        <TabsContent value="metricas" className="mt-6">
          <MetricsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
